import React, { useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import PhotoStrip from './components/PhotoStrip';
import Leaderboard from './components/Leaderboard';
import Callback from './components/Callback';
import ReviewsAndGallery from './components/ReviewsAndGallery';
import Social from './components/Social';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    const scrollToSection = () => {
      const target = window.location.hash === '#reviews' || window.location.pathname.includes('/reviews')
        ? 'reviews'
        : window.location.hash === '#leaderboard'
        ? 'leaderboard'
        : null;

      if (target) {
        const section = document.getElementById(target);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };

    scrollToSection();
    window.addEventListener('hashchange', scrollToSection);
    return () => window.removeEventListener('hashchange', scrollToSection);
  }, []);

  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <div className="divider" />
      <HowItWorks />
      <PhotoStrip />
      <div className="divider" />
      <Leaderboard />
      <div className="divider" />
      <Callback />
      <ReviewsAndGallery />
      <Social />
      <Footer />
    </>
  );
}

export default App;
